let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3WLlm")).then(() => parcelRequire('7MEzT'));